import React from "react";
import img1 from "../../../assets/new-4.jpeg";
import img2 from "../../../assets/new-2.png";
import img3 from "../../../assets/new-3.png";
import img4 from "../../../assets/new-1.jpeg";
import img5 from "../../../assets/new-5.png";
import img6 from "../../../assets/new-6.png";
import img7 from "../../../assets/new-7.png";
import img8 from "../../../assets/new-8.jpeg";
import img9 from "../../../assets/new-5.png";

// import iphoneFrame from "../../../assets/iphone-frame.png";

import videoThumb from "../../../assets/video-thumb.webp";
// import videoThumb from "../../../assets/Korn Interactive Laminates - Fan Vid Uploads.mp4";

// import mobileVideo from "../../../assets/mobile.mp4"
import mobileVideo from "../../../assets/new-video.mp4";
// import mobileVideo from "../../../assets/Korn Interactive Laminates - Fan Vid Uploads.mp4";

import { Link } from "react-router-dom";

const CreateMusic = () => {
  return (
    <div className="create-music mt-[-120px] relative z-[200]">
      <div className="container mx-auto">
        <div className="text-center">
          <h2
            className="text-[30px] lg:text-[40px] font-bold"
            style={{ lineHeight: "1.2" }}
          >
            We turn your photo <br />{" "}
            <span className="besley fw-light">product </span> into a time
            capsule
          </h2>
          <p className="lg:w-[40%] mx-auto mt-8 text-lg">
            Interactive provides a premier ecosystem of novel AR and QR services
            which radically increase fan engagement & data collection, helping
            artists and media companies substantially grow their revenue.
          </p>
        </div>
      </div>

      <div className="w-full relative grid my-[50px] lg:my-[240px] grid-cols-2 lg:grid-cols-9 gap-[10px] lg:gap-[50px] justify-between items-center lg:scale-[1.06]">
        <img
          src={img1}
          className="h-[150px] w-full object-cover lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />
        <img
          src={img2}
          className="h-[150px] w-full object-cover lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />
        <img
          src={img3}
          className="h-[150px] w-full object-cover lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />
        <img
          src={img4}
          className="h-[150px] w-full object-cover lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />
        <div className="video-holder lg:col-span-1 col-span-2">
          {/* <img src={iphoneFrame} className="absolute iphone-frame" alt="" /> */}
          <video
            playsinline="playsinline"
            autoplay="autoplay"
            loop="loop"
            muted="muted"
            preload="metadata"
            poster={videoThumb}
            className="lg:absolute w-[220px] object-cover lg:left-[50%] lg:top-[50%] lg:translate-x-[-50%] lg:translate-y-[-50%] mx-auto block col-span-2 lg:mt-0 mt-10"
          >
            <source src={mobileVideo} type="video/mp4" />
            <img src={videoThumb} alt="video thumb" />
          </video>
        </div>
        <img
          src={img5}
          className="h-[150px] w-full object-cover hidden lg:block lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />
        <img
          src={img6}
          className="h-[150px] w-full object-cover lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />
        <img
          src={img7}
          className="h-[150px] w-full object-cover lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />
        <img
          src={img8}
          className="h-[150px] w-full object-cover lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />
        <img
          src={img9}
          className="block lg:hidden h-[150px] w-full object-cover lg:w-auto mx-auto bg-white p-[10px] shadow-lg"
          alt=""
        />

        {/* <video src={mobileVideo} className='lg:absolute h-[450px] w-auto lg:left-[50%] lg:top-[50%] lg:translate-x-[-50%] lg:translate-y-[-50%] mx-auto block col-span-2 lg:mt-0 mt-10' playsinline webkit-playsinline autoPlay muted loop></video> */}


      </div>

      <div className="container mx-auto">
        <div className="text-center">
          <p className="lg:w-[50%] mx-auto text-lg mb-12">
            Our AR-QR codes allow fan data collection, password protected
            content, location-based content, and timed content shown on physical
            products. No apps required.
          </p>

          <Link
            to="/how-it-works"
            className="text-white bg-black border-0 uppercase px-6 py-4 rounded-[3px] font-semibold mt-10"
          >
            How it works
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CreateMusic;
